/* Knysna Jewellers on Horizon: South Africa clock (open/closed per shop, SA public holidays, Waterfront seasons),
   colour finder, shop switcher. Source: BrandGrowth-Africa templates/kj-redesign/theme/.
   Ported from the approved preview v4. Everything it touches is complete without it. */
(function () {
  /* ---- South Africa clock (Africa/Johannesburg, UTC+2, no daylight saving) ---- */
  function sa() {
    try {
      var p = new Intl.DateTimeFormat('en-GB', { timeZone: 'Africa/Johannesburg', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
      var o = {}; p.forEach(function (x) { o[x.type] = x.value; });
      return { y: +o.year, mo: +o.month, d: +o.day, h: +o.hour % 24, m: +o.minute };
    } catch (e) { var d = new Date(Date.now() + 2 * 3600e3); return { y: d.getUTCFullYear(), mo: d.getUTCMonth() + 1, d: d.getUTCDate(), h: d.getUTCHours(), m: d.getUTCMinutes() }; }
  }
  var data = {};
  try { data = JSON.parse(document.getElementById('kj-hours').textContent); } catch (e) {}
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  function ymd(t) { return t.toISOString().slice(0, 10); }
  function easter(y) { var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451), mo = Math.floor((h + l - 7 * m + 114) / 31), da = ((h + l - 7 * m + 114) % 31) + 1; return Date.UTC(y, mo - 1, da); }
  var cache = {};
  function holidays(y) { /* SA public holidays; one on a Sunday also makes the Monday a holiday */
    if (cache[y]) return cache[y];
    var out = {};
    (data.fixedHolidays || []).forEach(function (md) { var t = new Date(y + '-' + md + 'T00:00:00Z'); out[ymd(t)] = 1; if (t.getUTCDay() === 0) out[ymd(new Date(t.getTime() + 864e5))] = 1; });
    var e = easter(y); [-2, 1].forEach(function (k) { out[ymd(new Date(e + k * 864e5))] = 1; });
    (data.extraHolidays || []).forEach(function (d) { out[d] = 1; });
    return (cache[y] = out);
  }
  function hoursOn(code, t) { /* t = a UTC date standing for a South African calendar day */
    var shop = (data.shops || {})[code]; if (!shop) return null;
    if ((data.closed || []).indexOf(ymd(t).slice(5)) > -1) return null;
    var mo = t.getUTCMonth() + 1, plan = shop.week ? shop : (mo >= 9 || mo <= 4 ? shop.summer : shop.winter);
    if (holidays(t.getUTCFullYear())[ymd(t)]) return plan.holiday; /* public-holiday hours, Sundays too (preview v4 rule) */
    var wd = DAYS[t.getUTCDay()];
    return plan.week[wd] || null;
  }
  function hh(n) { return (n < 10 ? '0' : '') + n + ':00'; }
  function status(code) {
    var t = sa(), day = new Date(Date.UTC(t.y, t.mo - 1, t.d)), now = t.h + t.m / 60, hrs = hoursOn(code, day);
    if (hrs && now >= hrs[0] && now < hrs[1]) return { open: true, close: hrs[1] };
    for (var k = 0; k < 10; k++) {
      var d = new Date(day.getTime() + k * 864e5), h = hoursOn(code, d);
      if (!h || (k === 0 && now >= h[0])) continue;
      return { open: false, opens: h[0], when: k === 0 ? 'today' : k === 1 ? 'tomorrow' : LONG[d.getUTCDay()] };
    }
    return { open: false };
  }
  function pill(st) {
    if (st.open) return 'Open now · until ' + hh(st.close);
    if (st.opens == null) return 'Closed now';
    return 'Closed now · opens at ' + hh(st.opens) + ' ' + st.when;
  }
  function line(code, st) {
    var n = data.shops[code].name;
    if (st.open) return n + ' is open until ' + hh(st.close) + ' today';
    if (st.opens == null) return n + ' is closed';
    return n + ' opens at ' + hh(st.opens) + ' ' + (st.when === 'today' || st.when === 'tomorrow' ? st.when : 'on ' + st.when);
  }
  function tick() {
    document.querySelectorAll('[data-kj-status]').forEach(function (el) {
      var st = status(el.getAttribute('data-shop'));
      el.textContent = pill(st); el.setAttribute('data-open', st.open ? 'true' : 'false'); el.hidden = false;
    });
    document.querySelectorAll('[data-kj-announce]').forEach(function (el) {
      var keys = Object.keys(data.shops || {}); if (!keys.length) return;
      /* the open shop first, then the one that opens soonest */
      el.textContent = keys.map(function (c) { return [c, status(c)]; })
        .sort(function (a, b) { return (b[1].open ? 1 : 0) - (a[1].open ? 1 : 0); })
        .map(function (x) { return line(x[0], x[1]); }).join(' · ');
      el.hidden = false;
    });
  }
  window.kjHours = { hoursOn: hoursOn, holidays: holidays, status: status };
  tick(); setInterval(tick, 60000);

  function press(list, btn) { list.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); }); }

  /* ---- I1: find your stone by colour (every card is visible without JS) ---- */
  document.querySelectorAll('[data-kj-finder]').forEach(function (finder) {
    var scope = finder.closest('.kj') || document;
    var chips = Array.prototype.slice.call(finder.querySelectorAll('[data-colour]'));
    var cards = Array.prototype.slice.call(scope.querySelectorAll('[data-kj-cards] > li'));
    finder.hidden = false;
    finder.addEventListener('click', function (e) {
      var b = e.target.closest('[data-colour]'); if (!b) return;
      press(chips, b);
      var c = b.getAttribute('data-colour');
      cards.forEach(function (li) { li.classList.toggle('kj-dim', c !== 'all' && (li.getAttribute('data-colours') || '').split(' ').indexOf(c) < 0); });
    });
  });

  /* ---- I2: shop switcher (both shops listed without JS) ---- */
  document.querySelectorAll('[data-kj-switch]').forEach(function (sec) {
    var bar = sec.querySelector('.kj-switch'); if (!bar) return;
    var btns = Array.prototype.slice.call(bar.querySelectorAll('[data-pick]'));
    var panels = sec.querySelectorAll('[data-panel]');
    bar.hidden = false;
    bar.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pick]'); if (!b) return;
      press(btns, b);
      var v = b.getAttribute('data-pick');
      panels.forEach(function (p) { p.hidden = !(v === 'both' || p.getAttribute('data-panel') === v); });
    });
  });
})();